import AdminPlans from '../AdminPlans';
import { useI18n } from '../../context/useI18n';
import MastersBackHeader from '../common/MastersBackHeader';

/** Gestión de planes propios del gimnasio virtual (crear, editar, ciclos). */
export default function GymMastersPlans({ onBack, scopeGymId = null }) {
  const { t } = useI18n();

  return (
    <div className="dashboard-main-view surface-readable d28d-admin-surface space-y-4 notranslate" translate="no">
      <MastersBackHeader
        onBack={onBack}
        title={t('gym.masters.plans', 'Planes comerciales')}
      />
      <div className="rounded-xl border border-slate-200 bg-white p-4 text-sm text-stone-800 ui-light-panel">
        <p className="font-semibold text-stone-900 mb-1">
          <span translate="no">{t('gym.masters.plans', 'Planes comerciales')}</span>
          {' — '}
          <span translate="no">{t('gym.masters.plans_page_lead', 'planes comerciales de tu sede')}</span>
        </p>
        <p className="m-0">
          {t(
            'gym.masters.plans_help',
            'Aquí defines los planes comerciales (precio, nombre, módulos). Crea primero ciclos y programas en Maestros, luego asígnalos al crear cada plan.',
          )}
        </p>
      </div>
      <AdminPlans
        mode="d28d"
        embedded
        gymId={scopeGymId}
        onBack={onBack}
        hideProgramColumn
        title={t('gym.masters.plans', 'Planes comerciales')}
      />
    </div>
  );
}
